export default "__VITE_ASSET__DKgyILHs__"